import { sessionCache } from "modules/auth";
import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { checkSession } from "services";
import { RootState } from "store";

export const CheckSession = () => {
    const signIn = useSelector((state: RootState) => state.signIn);

    const ping = useCallback(async () => {
        if (!signIn.signInSuccess || !signIn.user?.ePoljoprivredaGuid) return;
        const isSessionActive = await checkSession(signIn.user?.accessToken);
        sessionCache()?.updateIsActive(isSessionActive);
    }, [signIn]);

    useEffect(() => {
        window.onfocus = ping;

        ping();
    }, [ping]);

    return <></>;
};

export default CheckSession;
